document.addEventListener("DOMContentLoaded", () => {
  const newsletterForm = document.querySelector(".newsletter-form");
  const newsletterInput = document.querySelector(".newsletter-input");
  const newsletterMessage = document.querySelector(".newsletter-message");
  const submitButton = document.querySelector(".newsletter-submit");

  if (
    !newsletterForm ||
    !newsletterInput ||
    !newsletterMessage ||
    !submitButton
  )
    return;

  const showMessage = (message, isError = true) => {
    newsletterMessage.textContent = message;
    newsletterMessage.style.color = isError ? "#ff4444" : "#4CAF50";
    newsletterMessage.style.display = "block";
  };

  const hideMessage = () => {
    newsletterMessage.style.display = "none";
  };

  newsletterInput.addEventListener("input", () => {
    hideMessage();
  });

  newsletterForm.addEventListener("submit", async (event) => {
    event.preventDefault();

    const inputValue = newsletterInput.value.trim();
    const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inputValue);

    if (!isValidEmail) {
      showMessage("Please enter a valid email address");
      return;
    }

    submitButton.disabled = true;
    const originalButtonText = submitButton.textContent;
    submitButton.textContent = "SUBMITTING...";
    hideMessage();

    try {
      const formData = new FormData(newsletterForm);

      const response = await fetch(newsletterForm.action, {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/javascript",
        },
      });

      if (response.ok) {
        const responseText = await response.text();

        if (
          responseText.includes("contact[tags]") ||
          responseText.includes("accepts_marketing")
        ) {
          showMessage("Thank you for subscribing!", false);
          newsletterInput.value = "";

          setTimeout(() => {
            hideMessage();
          }, 5000);
        } else {
          showMessage("Thank you for subscribing!", false);
          newsletterInput.value = "";

          setTimeout(() => {
            hideMessage();
          }, 5000);
        }
      } else {
        const errorText = await response.text();

        if (
          errorText.includes("already subscribed") ||
          errorText.includes("already exists") ||
          errorText.includes("is already on the list")
        ) {
          showMessage("You are already subscribed!", false);
        } else if (errorText.includes("Invalid email")) {
          showMessage("Please enter a valid email address");
        } else {
          showMessage("Something went wrong. Please try again.");
        }
      }
    } catch (error) {
      showMessage("Network error. Please check your connection and try again.");
    } finally {
      submitButton.disabled = false;
      submitButton.textContent = originalButtonText;
    }
  });
});
